module.exports = __webpack_public_path__ + "static/media/Sequence.f08fd861.jpeg";